import { ComponentPropsWithoutRef } from "react";
import * as styles from "./Image.css";
import clsx from "clsx";

export type ImageProps = {
  applyTransform?: boolean;
} & ComponentPropsWithoutRef<"img">;

export const Image = ({
  applyTransform = true,
  src = "",
  width = 962,
  ...props
}: ImageProps) => {
  // Transforms width value taken from designs (viewport width 962) into value relative to max image width of 1920 width.
  const transformedWidth = Math.round(Number(width) / (962 / 1920));

  const transformedSrc = `${src.substring(0, src.lastIndexOf("/"))}/width=${transformedWidth}`;

  return (
    // <picture className={styles.picture}>
    <img
      {...props}
      src={applyTransform ? transformedSrc : src}
      className={clsx(styles.image, props.className)}
      alt=""
      draggable="false"
    />
    // </picture>
  );
};
